module.exports = __webpack_public_path__ + "img/kurume.27fc6cfc.jpg";